import { daysOfWeek } from "@sellar-io/common";

export type DeliveryAreaFormRef = {
  submitForm: () => void;
  isDirty: () => boolean;
};

export const deliveryDays: { value: daysOfWeek; viewValue: string }[] = [
  {
    value: "monday",
    viewValue: "Monday",
  },
  {
    value: "tuesday",
    viewValue: "Tuesday",
  },
  {
    value: "wednesday",
    viewValue: "Wednesday",
  },
  {
    value: "thursday",
    viewValue: "Thursday",
  },
  {
    value: "friday",
    viewValue: "Friday",
  },
  {
    value: "saturday",
    viewValue: "Saturday",
  },
  {
    value: "sunday",
    viewValue: "Sunday",
  },
];
